import React from "react";
import ChatMessageList from "./ChatMessageList";
import ChatInput from "./ChatInput";
import { ChatMessage } from "@/types";

interface Props {
  messages: ChatMessage[];
  isTyping: boolean;
  onSendMessage: (input: string) => void;
}

const MindfulChatBot: React.FC<Props> = ({ messages, isTyping, onSendMessage }) => (
  <div className="flex flex-col h-full max-w-4xl w-full mx-auto bg-transparent overflow-hidden">
    <div className="flex flex-col flex-1 min-h-0">
      <ChatMessageList messages={messages} isTyping={isTyping} />
      <ChatInput onSendMessage={onSendMessage} isTyping={isTyping} />
    </div>
  </div>
);

export default MindfulChatBot;
